module.exports = __webpack_public_path__ + "img/maximize.92a19073.svg";